import React, { useState } from 'react';
import './createVavaka.scss';
import { Button, CircularProgress, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as vavakaService from "../../../services/VavakaService";
import BackButton from './../../../components/BackButton/BackButton';
import Swal from 'sweetalert2';

const CreateVavaka = () => {
  const [lohateny, setLohateny] = useState("");
  const [vavaka, setVavaka] = useState("");
  const [audioVavaka, setAudioVavaka] = useState(null); 
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
  
    setIsLoading(true);
  
    const formData = new FormData();
    formData.append('lohateny', lohateny);
    formData.append('vavaka', vavaka);
    formData.append('audio', audioVavaka);
  
    vavakaService.addVavaka(formData)
      .then((res) => {
        if (res.status === 200) {
          Swal.fire(
            'Prière créée!',
            'Création de la prière avec succès',
            'success'
          ).then(() => {
            navigate('/vavaka');
          });
        }
      })
      .catch((err) => {
        Swal.fire(
          'Nope',
          'Une erreur s\'est produite',
          'error'
        );
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };  

  return (
    <div>
      <div className="back" style={{margin:"10px 0 0 30px"}}>
        <BackButton />
      </div>

      <div className="addVavaka">
        <span className='titre'>Nouveau Vavaka</span>

        <div className='form-vavaka'>
          <form onSubmit={handleSubmit}>
            <TextField
              type="text"
              label="Lohateny"
              variant="outlined"
              margin='normal'
              multiline
              onChange={(e) => setLohateny(e.target.value)} 
              required
            />
            <TextField
              type="text"
              label="Vavaka"
              variant="outlined"
              margin='normal'
              multiline
              onChange={(e) => setVavaka(e.target.value)} 
            />
            <TextField
              type="file"
              label="Ajouter une audio"
              variant="outlined"
              margin='normal'
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setAudioVavaka(e.target.files[0])} 
              accept="audio/mp3"
              required
            />
            <Button type="submit" variant="contained" disabled={isLoading}>
              {isLoading ? <CircularProgress size={24}/> : "Valider"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateVavaka;
